import { jsx as _jsx } from "react/jsx-runtime";
import { Card, styled, Typography } from '@mui/material';
import { forwardRef } from 'react';
function canWrapLabel(label) {
    if (!label) {
        return false;
    }
    return label.split(' ').length > 1;
}
const RefCard = forwardRef(function BaseCard(props, ref) {
    return _jsx(Card, { ...props, ref: ref, variant: "outlined", tabIndex: -2 });
});
export const BaseCard = styled(RefCard, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    borderRadius: 12,
    padding: 10,
    backgroundColor: error ? theme.palette.error.main : 'none',
    color: error ? theme.palette.error.contrastText : 'inherit',
    boxShadow: 'none',
    height: '100%',
    transition: 'all 0.2s linear',
    ':focus': {
        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.6)',
    },
}));
export const BaseCardLabel = styled(Typography)(({ label, lines = 2 }) => ({
    ...(canWrapLabel(label)
        ? {
            display: '-webkit-box',
            WebkitLineClamp: lines,
            WebkitBoxOrient: 'vertical',
        }
        : {
            whiteSpace: 'nowrap',
        }),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));
